exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.clearfix[data-v-4a6b627b]:before,\n.clearfix[data-v-4a6b627b]:after {\n  display: table;\n  content: \"\";\n}\n.clearfix[data-v-4a6b627b]:after {\n  clear: both;\n}\n.box-card[data-v-4a6b627b] {\n  width: 650px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-4a6b627b","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/sass-resources-loader/lib/loader.js?{"resources":["/data/wwwroot/shop.yaoking.cn/build/espier-retail-manage/app/src/style/theme.scss","/data/wwwroot/shop.yaoking.cn/build/espier-retail-manage/app/src/style/_mixin.scss"]}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/view/member/selfservice/formtemplateadd.vue
// module id = 1437
// module chunks = 0